module.exports = __webpack_public_path__ + "images/arrow-down-white.30cfeda699853dc1d798058f9e9a3be9.svg";